// extracted by mini-css-extract-plugin
module.exports = {"tag":"style__tag__G9XWZ","green":"style__green__tvfHe","red":"style__red__ncffF","yellow":"style__yellow__LaNWY"};